import React, { Component } from 'react'
import * as moment from 'moment'
import NoSleep from 'nosleep.js/dist/NoSleep'

import {
  Modal,
  Typography,
  Paper,
  LinearProgress,
  Grid,
  Button
} from 'material-ui'
import AddIcon from 'material-ui-icons/Add'
import RemoveIcon from 'material-ui-icons/Remove'
import CheckIcon from 'material-ui-icons/Check'
import ReplayIcon from 'material-ui-icons/Replay'
import PauseIcon from 'material-ui-icons/Pause'
import PlayArrowIcon from 'material-ui-icons/PlayArrow'
import IconButton from 'material-ui/IconButton'
import ChromeReaderModeIcon from 'material-ui-icons/ChromeReaderMode'
import RefreshIcon from 'material-ui-icons/Refresh'
import ClearIcon from 'material-ui-icons/Clear'
import VisibilityIcon from 'material-ui-icons/Visibility'
import VisibilityOffIcon from 'material-ui-icons/VisibilityOff'

export default class TimerModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      open: false,
      openZero: false,

      token: 'session',
      isPaused: false,
      isUpdated: false,
      isSessionNow: true,
      eAngle: 0,
      session: 30,
      initialStart: true,
      minsRead: 0,
      currentSession: [],
      isCommented: false,
      comment: '',
      sleep: 'Will Sleep',
      timer: 30 * 60,
      initialStartTimer: true
    }
    this.noSleep = new NoSleep()
  }

  // reset state if the seeded prop is updated
  componentWillReceiveProps(nextProps) {
    if (nextProps.open !== this.props.open) {
      this.setState({ open: nextProps.open })
    }
    if (nextProps.event !== this.props.event) {
      this.setState({ event: nextProps.event })
    }
  }

  handleClose = () => {
    this.setState({
      isSessionNow: true,
      initialStartTimer: true,
      initialStart: true
    })
    this.updateState(this.state.session)
    this.props.onClose()
    this.setState({
      open: false
    })
  }

  handleOpenZero = () => {
    this.setState({ openZero: true })
  }

  handleCloseZero = () => {
    this.setState({ openZero: false })
  }
  updateStats = (newTime, token, didUpdate) => {
    if (token === 'session') {
      this.setState({
        session: newTime
      })

      this.setState({
        timer: newTime * 60,
        isUpdated: didUpdate
      })
    }
  }

  drawPieSlice = (
    ctx,
    centerX,
    centerY,
    radius,
    startAngle,
    endAngle,
    color
  ) => {
    ctx.fillStyle = color
    ctx.beginPath()
    ctx.moveTo(centerX, centerY)
    ctx.arc(centerX, centerY, radius, startAngle, endAngle)
    ctx.closePath()
    ctx.fill()
  }

  // starts the Pomodoro Timer
  startPomodoro = () => {
    if (this.state.initialStart) {
      this.setState({ timeStart: moment().format() })
    }

    this.setState({ initialStart: false, initialStartTimer: false })

    // timer according session or break
    var timer
    // audio links
    var wav = process.env.PUBLIC_URL + '/oringz-w425.mp3'
    var audio = new Audio(wav)

    var canvas = document.getElementById('draw-circle')
    var context = canvas.getContext('2d')
    var centerX = canvas.width / 2
    var centerY = canvas.height / 2
    var radius = centerX
    var offset
    offset = 2 * Math.PI / (this.state.session * 60)
    context.strokeStyle = '#00FF00'

    if (this.state.timer > 0) {
      timer = this.state.timer
    } else {
      timer = this.state.session * 60
    }

    // if we time changed redraw canvas
    if (this.state.isUpdated) {
      context.clearRect(0, 0, canvas.width, canvas.height)
      this.setState({
        eAngle: 0
      })
      //('timer is reset.')
    }

    // timer starting
    if (!this.state.isPaused) {
      this.noSleep.enable()
      this.setState({ sleep: 'No Sleep' })
      //('sleep no no')
      //('Started: ' + moment().calendar())
      this.setState({
        interval: setInterval(
          function() {
            // timer not ended
            if (--timer >= 0) {
              context.fillStyle = 'rgba(80, 227, 194, 1)'
              context.arc(centerX, centerY, radius, 0, Math.PI * 2, false)

              context.fill()
              context.beginPath()

              this.drawPieSlice(
                context,
                centerX,
                centerY,
                radius,
                1.5 * Math.PI,
                1.5 * Math.PI + this.state.eAngle,
                'rgba(97, 97, 97, 1)'
              )

              this.setState({
                timer: timer,
                eAngle: this.state.eAngle + offset
              })
            } else {
              this.noSleep.disable()
              this.setState({ sleep: 'Will Sleep' })
              //('sleep yes')
              if (this.state.isSessionNow) {
                // timer ended
                // play audio
                audio.play()
                // change state
                this.setState({
                  isSessionNow: !this.state.isSessionNow,
                  isPaused: false,
                  eAngle: 0
                })
                // clear interval
                clearInterval(this.state.interval)
                // clear canvas
                context.clearRect(0, 0, canvas.width, canvas.height)
                // todo write into database
                this.updateEvent()
              }
            }
          }.bind(this),
          1000
        )
      })
    } else {
      this.noSleep.disable()
      this.setState({ sleep: 'Will Sleep' })
      //('sleep yes')
      clearInterval(this.state.interval)
    }

    this.setState({
      isPaused: !this.state.isPaused,
      isUpdated: false
    })
  }

  updateEvent = () => {
    var newEvent = Object.assign({}, this.state.event)
    newEvent.startedAt = this.state.timeStart
    newEvent.completedAt = moment().format()
    var s = moment(new Date(newEvent.startedAt))
    var e = moment(new Date(newEvent.completedAt))
    if (s.isSameOrBefore(e)) {
      newEvent.minutes = e.diff(s, 'minutes')
    } else {
      newEvent.minutes = 0
    }
    this.props.update(newEvent)
    this.setState({
      event: newEvent
    })
    this.handleClose()
  }

  // display time in minutes and seconds
  displayTime = () => {
    var mins = parseInt(this.state.timer / 60, 10)
    var secs = parseInt(this.state.timer % 60, 10)

    mins = mins < 10 ? '0' + mins : mins
    secs = secs < 10 ? '0' + secs : secs

    return mins + ':' + secs + ' (' + this.state.sleep + ')'
  }

  handleTimeUp = () => {
    this.updateState(this.state.session + 10)
  }

  handleTimeDown = () => {
    this.updateState(this.state.session - 10)
  }

  handleReset = () => {
    this.setState({
      isSessionNow: true
    })
    this.updateState(this.state.session)
  }

  handleNoSleep = () => {
    this.noSleep.enable()
    this.setState({ sleep: 'No Sleep' })
  }

  handleWillSleep = () => {
    this.noSleep.disable()
    this.setState({ sleep: 'Will Sleep' })
  }

  handleComplete = () => {
    if (parseInt(this.state.session - this.state.timer / 60, 10) < 1) {
      //('0 mins read, so no new record')
      this.handleOpenZero()
      return
    }

    this.setState({ isCompleted: true })
    this.manulCompletePomodoro()
  }

  // starts the Pomodoro Timer
  manulCompletePomodoro = () => {
    // timer according session or break

    var canvas = document.getElementById('draw-circle')
    var context = canvas.getContext('2d')

    //('Started: ' + moment().calendar())
    this.setState({
      interval: setInterval(
        function() {
          // timer ended
          // change state
          this.setState({
            isSessionNow: !this.state.isSessionNow,
            isPaused: false,
            eAngle: 0
          })
          // clear interval
          clearInterval(this.state.interval)
          // clear canvas
          context.clearRect(0, 0, canvas.width, canvas.height)
        }.bind(this),
        1000
      )
    })

    // todo write into database
    this.updateEvent()
  }

  updateState = newTime => {
    var updateTime = newTime
    // max time in mins 60
    var max = 120
    // min time in mins 1
    var min = 10

    // did update time
    var isUpdated = true

    if (updateTime > max) {
      updateTime = max
    } else if (updateTime < min) {
      updateTime = min
    }

    //
    this.setState({
      session: updateTime,
      eAngle: 0
    })

    this.updateStats(updateTime, this.state.token, isUpdated)
    this.resetPomodoro()
  }

  // reset the Pomodoro Timer
  resetPomodoro = () => {
    // timer according session or break

    var canvas = document.getElementById('draw-circle')
    var context = canvas.getContext('2d')
    var centerX = canvas.width / 2
    var centerY = canvas.height / 2
    var radius = centerX

    // if we time reset redraw canvas
    context.clearRect(0, 0, canvas.width, canvas.height)
    this.setState({
      eAngle: 0
    })

    //('timer is reset manually.')
    context.fillStyle = 'rgba(80, 227, 194, 1)'
    context.arc(centerX, centerY, radius, 0, Math.PI * 2, false)

    context.fill()
  }

  render() {
    return (
      <div>
        <Modal
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          open={this.state.open}
          onClose={this.handleClose}
          className="modalAddTodayDark"
          disableBackdropClick
          disableAutoFocus
        >
          <div className="paperAddToday">
            <div id={this.state.token} className="divAddTpday">
              <div className="divClearButton">
                {!this.state.isPaused && (
                  <IconButton
                    className="btn btn-default btn-style"
                    onClick={this.handleClose}
                  >
                    <ClearIcon className="iconClearDark" />
                  </IconButton>
                )}
              </div>
              <div style={{ height: 100, width: '100%', textAlign: 'center' }}>
                {this.state.isPaused ? (
                  <div>
                    <div>
                      <IconButton className="btn btn-default btn-style" />
                    </div>
                    <Button
                      onClick={this.startPomodoro}
                      className="iconDark"
                      size="small"
                    >
                      <span style={{ fontSize: 15, color: 'lightgrey' }}>
                        Pause
                      </span>
                    </Button>
                  </div>
                ) : this.state.eAngle === 0 ? (
                  <div>
                    <div style={{ height: 38 }}>
                      <IconButton
                        onClick={this.handleTimeDown}
                        disabled={this.state.isPaused}
                        style={{
                          color: 'lightgrey',
                          height: 28,
                          width: 28,
                          margin: 5
                        }}
                      >
                        <RemoveIcon />
                      </IconButton>

                      <span style={{ fontSize: 15, color: 'lightgrey' }}>
                        {this.state.session} mins
                      </span>

                      <IconButton
                        onClick={this.handleTimeUp}
                        disabled={this.state.isPaused}
                        style={{
                          color: 'lightgrey',
                          height: 28,
                          width: 28,
                          margin: 5
                        }}
                      >
                        <AddIcon />
                      </IconButton>
                    </div>
                    <Button
                      onClick={() => this.handleOpenAdd(moment().format('l'))}
                      className="iconDark"
                      size="small"
                    >
                      <span style={{ fontSize: 15, color: 'lightgrey' }}>
                        Manually Add
                      </span>
                    </Button>
                  </div>
                ) : (
                  <div>
                    <div style={{ height: 38 }}>
                      <IconButton className="btn btn-default btn-style" />
                    </div>
                    <Button
                      onClick={this.startPomodoro}
                      className="iconDark"
                      size="small"
                    >
                      <span style={{ fontSize: 15, color: 'lightgrey' }}>
                        Continue
                      </span>
                    </Button>
                  </div>
                )}
              </div>
            </div>

            <div id="timer" className="centerBlock">
              <canvas id="draw-circle" width="250" height="250" />
              <div id="pause" className="innerWrapTimer">
                {this.state.isPaused ? (
                  <IconButton
                    onClick={this.startPomodoro}
                    disableRipple
                    size="large"
                    style={{
                      width: 180,
                      height: 180,
                      margin: 8
                    }}
                  >
                    <PauseIcon
                      style={{
                        color: 'rgba(255, 255, 255, 0.8)',
                        fontSize: 170
                      }}
                    />
                  </IconButton>
                ) : (
                  <IconButton
                    onClick={this.startPomodoro}
                    disableRipple
                    size="large"
                    style={{
                      width: 180,
                      height: 180,
                      margin: 8
                    }}
                  >
                    <PlayArrowIcon
                      id="timerPlay"
                      style={{
                        color: this.state.initialStart
                          ? 'rgba(80, 227, 194, 1)'
                          : 'rgba(255, 255, 255, 0.8)',
                        fontSize: 170
                      }}
                    />
                  </IconButton>
                )}
              </div>

              <div className="innerWrapTimerText">
                <div id="curr-time">{this.displayTime()}</div>
              </div>
            </div>

            <div id="buttons" className="centerBlockBtns">
              <Button
                onClick={this.handleComplete}
                disabled={this.state.isPaused}
                className="iconDark"
                size="small"
              >
                <CheckIcon style={{ color: 'lightgrey' }} />
              </Button>
              <Button
                onClick={this.handleReset}
                disabled={this.state.isPaused}
                className="iconDark"
                size="small"
              >
                <ReplayIcon style={{ color: 'lightgrey' }} />
              </Button>
              {this.state.sleep === 'Will Sleep' ? (
                <Button
                  onClick={() => this.handleNoSleep()}
                  disabled={this.state.isPaused}
                  className="iconDark"
                  size="small"
                >
                  <VisibilityOffIcon style={{ color: 'lightgrey' }} />
                </Button>
              ) : (
                <Button
                  onClick={() => this.handleWillSleep()}
                  disabled={this.state.isPaused}
                  className="iconDark"
                  size="small"
                >
                  <VisibilityIcon style={{ color: 'lightgrey' }} />
                </Button>
              )}
            </div>
            <Paper
              style={{
                margin: 32,
                backgroundColor: 'dimgrey',
                boxShadow: '0px 0px 6px #888888',
                height: 180
              }}
            >
              {this.state.event && (
                <Grid container spacing={0}>
                  <Grid item className="gridLeftDark">
                    <div id="bookblock" className="bookBlock">
                      <ChromeReaderModeIcon
                        style={{
                          fontSize: 60,
                          color: 'rgba(0, 0, 0, 0.1)'
                        }}
                      />
                      {this.state.event.tracker && (
                        <Typography
                          variant="body1"
                          id="projectName"
                          style={{
                            paddingLeft: 8,
                            paddingRight: 2,
                            textAlign: 'left',
                            fontSize: 12,
                            color: 'silver'
                          }}
                        >
                          {this.state.event.tracker.type !== 'reading'
                            ? this.state.event.tracker.name
                            : this.state.event.book &&
                              this.state.event.book.name}
                        </Typography>
                      )}
                      {this.state.event.book && (
                        <Typography
                          variant="caption"
                          id="status"
                          style={{
                            paddingLeft: 8,
                            paddingRight: 8,
                            fontSize: 9,
                            textAlign: 'left',
                            color: 'darkgray'
                          }}
                        >
                          {this.state.event.book.author}
                        </Typography>
                      )}
                      {this.state.event.task && (
                        <Typography
                          variant="caption"
                          id="status"
                          style={{
                            paddingLeft: 8,
                            paddingRight: 8,
                            fontSize: 9,
                            textAlign: 'left',
                            color: 'darkgray'
                          }}
                        >
                          {this.state.event.task.name}
                        </Typography>
                      )}
                    </div>
                    {this.state.initialStartTimer &&
                      this.state.event.tracker &&
                      (this.state.event.tracker.type === 'project' ||
                        this.state.event.tracker.type === 'reading') && (
                        <div style={{ textAlign: 'left', marginTop: 10 }}>
                          <IconButton
                            onClick={() => this.props.history.push('/projects')}
                            style={{
                              backgroundColor: 'dimgrey',
                              boxShadow: '0px 0px 6px #aaaaaa',
                              height: 20,
                              width: 20,
                              margin: 8
                            }}
                            size="small"
                          >
                            <RefreshIcon
                              style={{ color: 'lightgrey', fontSize: 16 }}
                            />
                          </IconButton>
                        </div>
                      )}
                  </Grid>
                  <Grid
                    item
                    container
                    direction="column"
                    spacing={0}
                    style={{
                      position: 'relative',
                      textAlign: 'left',
                      height: 120,
                      width: 150,
                      top: 25,
                      left: 46,
                      margin: 10
                    }}
                  >
                    <Grid item>
                      <IconButton />
                      <br />
                      <Typography
                        style={{
                          color: 'lightgrey',
                          fontSize: 14,
                          height: 20,
                          paddingTop: 10
                        }}
                      >
                        {this.state.event.subtask
                          ? this.state.event.subtask.name
                          : this.state.event.bookPref
                            ? 'At Page ' + this.state.event.bookPref.maxPage
                            : ''}
                      </Typography>
                      <div style={{ position: 'relative', top: 8 }}>
                        <Typography style={{ color: 'grey', fontSize: 12 }}>
                          Progress:{' '}
                          {this.state.event.bookPref
                            ? this.state.event.bookPref.percentRead
                            : 0}%{' '}
                          {this.state.event.bookPref &&
                          this.state.event.bookPref.percentRead >= 100 ? (
                            <CheckIcon
                              style={{ color: 'green', fontSize: 12 }}
                            />
                          ) : (
                            ''
                          )}
                        </Typography>
                        <LinearProgress
                          variant="determinate"
                          value={
                            this.state.event.bookPref
                              ? this.state.event.bookPref.percentRead
                              : 0
                          }
                          color={
                            this.state.event.bookPref &&
                            this.state.event.bookPref.percentRead >= 100
                              ? 'secondary'
                              : 'primary'
                          }
                        />
                      </div>
                    </Grid>
                  </Grid>
                </Grid>
              )}
            </Paper>
          </div>
        </Modal>
        <Modal
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          open={this.state.openZero}
          onClose={this.handleCloseZero}
        >
          <div className="modalZero">
            <Typography variant="body1" id="modal-title">
              Please read more than 1 min.{' '}
              <span role="img" aria-label="projects">
                {' '}
                📖
              </span>{' '}
              Enjoy your projects!
            </Typography>
            <br />
            <Button
              onClick={this.handleCloseZero}
              className="icon"
              size="small"
            >
              OK
            </Button>
          </div>
        </Modal>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/modals/Timer.js